module.exports = __webpack_public_path__ + "img/btn-loader.0d7b4d20.gif";